// Browse Talent Filter
// 

JLM.MD.TalentBrowseFilter = function( container, data_all ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let header, header_crumbs, but_close;
	
	
	
	// Variables: Public ________________________________________________________
	
	// References
	INSTANCE.f_name = null;
	INSTANCE.f_gender = null;
	
	// Data
	INSTANCE.matches = {};
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		let intro_descr, intro_toggle;
		
		// References
		intro_descr = $('.filter .introduction .description', container);
		intro_toggle = $('.toggle', intro_descr);
		header = $('.filter header', container);
		header_crumbs = $('ul', header);
		but_close = $('.controls button[data-action="close"]', container);
		
		// Fields: Common
		var f_name_input = $('#f_filter_name', container);
		INSTANCE.f_name = new JLM.MD.Textfield( f_name_input );
		INSTANCE.f_gender = new JLM.MD.DropdownList( $('#f_filter_gender', container) );
		
		// Events
		intro_toggle.on('click', function() {
			intro_descr.toggleClass('expanded');
		});
		header.on('click', mobileToggle);
		f_name_input.on('keypress', function(event) {
			if (event.which === 13) {
				event.preventDefault();
			}
		});
		INSTANCE.f_name.on('change', INSTANCE.onChange);
		INSTANCE.f_gender.on('change', INSTANCE.onChange);
		but_close.on('click', mobileClose);
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Open / Close area for mobile
	// 
	function mobileToggle() {
		let status = container.attr('data-mb-status');
		if ( status == 'open' ) mobileClose();
		else mobileOpen();
	}
	function mobileOpen() {
		container.attr('data-mb-status', 'open');
	}
	function mobileClose() {
		container.attr('data-mb-status', 'closed');
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// When filter changes
	// 
	INSTANCE.onChange = function() {
		INSTANCE.dispatchEvent('sup_change');
	};
	
	
	// Update crumbs
	// 
	INSTANCE.updateHeaderCrumbs = function( values ) {
		header_crumbs.empty();
		values.forEach(function( value ) {
			$('<li>' + value + '</li>').appendTo( header_crumbs );
		});
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};


// Methods: Static ______________________________________________________________

// Get label value from list of data
// 
JLM.MD.TalentBrowseFilter.getDataLabel = function( dataset, value ) {
	var i = dataset.length; while( i-- ) {
		if ( dataset[i].value == value ) {
			return dataset[i].label;
		}
	}
	return null;
};


// Break values up into country / city
// 
JLM.MD.TalentBrowseFilter.getLocationValues = function( location_value ) {
	let location_values = location_value.match(/([\w]{3})\/?(.*)?/),
		location_country = '',
		location_city = '';
	if ( $.isArray( location_values ) ) {
		location_country = location_values[1];
		location_city = location_values[2];
	}
	return { country: location_country, city: location_city };
};

